import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SelectionType } from '@swimlane/ngx-datatable';
import { NgxSpinnerService } from 'ngx-spinner';
import { InvoicesApiService } from 'src/app/core/services/api/invoices-api.service';
import { Invoice, InvoiceSearchParams, InvoiceStatus } from 'src/app/shared/models/financials/invoice';

@Component({
  selector: 'app-overdue-invoices-list',
  templateUrl: './overdue-invoices-list.component.html',
  styleUrls: ['./overdue-invoices-list.component.scss']
})
export class OverdueInvoicesListComponent implements OnInit {
  SelectionType = SelectionType;
  
  @Input() items: Invoice[] = [];
  @Input() count = 0;
  @ViewChild('hearingsTable') hearingsTable: any;
  
  @Output() updatedCount = new EventEmitter<number>();
  params: InvoiceSearchParams = new InvoiceSearchParams();
  constructor(private spinner: NgxSpinnerService,
    private invoicesApi: InvoicesApiService,
    private router: Router) {
      this.params.status.push(InvoiceStatus.Issued);
      if (!this.items.length) {
        this.loadItems();
      }
    }

  ngOnInit(): void {
  }


  loadItems() {
    this.spinner.show();
    this.invoicesApi.getInvoices(this.params).subscribe(
      r => {
        this.items = r.results;
        this.count = r.count;
        this.updatedCount.emit(r.count);
        this.spinner.hide();
      }
    )
  }

  onPage(page) {
    this.params.page = page.offset + 1;
    this.loadItems();
  }

}
